import { MetricPanel } from "./AnalyticsVisuals";
import { GroupsOutlined } from "@mui/icons-material";

import { SupplierAnalytics as SupplierAnalyticsType } from "../types";

interface SupplierAnalyticsProps {
  data?: SupplierAnalyticsType | null;
}

const SupplierAnalytics = ({ data }: SupplierAnalyticsProps) => {
  const rows = [
    ["Suppliers With Bills", data?.totalSuppliers ?? 0],
    ["Active Suppliers", data?.activeSuppliers ?? 0],
    ["Inactive Suppliers", data?.inactiveSuppliers ?? 0],
    ["Top Supplier", data?.topSupplier || "-"],
  ];

  return <MetricPanel title="Supplier Analytics" rows={rows} icon={<GroupsOutlined />} />;
};

export default SupplierAnalytics;
